import React, { useState } from 'react';
import { Dialog, DialogContent } from './ui/dialog';
import { X } from 'lucide-react';

export const RestaurantPhotosSection = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const restaurantImages = [
    {
      url: "https://customer-assets.emergentagent.com/job_le-tassili-resto/artifacts/unq8aor7_WhatsApp%20Image%202026-04-27%20at%2015.21.09.jpeg",
      alt: "Devanture Le Tassili Podium"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_le-tassili-resto/artifacts/br3777bp_WhatsApp%20Image%202026-04-27%20at%2015.21.08.jpeg",
      alt: "Salle du restaurant"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_le-tassili-resto/artifacts/21u7s7cg_WhatsApp%20Image%202026-04-27%20at%2015.21.08%20%281%29.jpeg",
      alt: "Comptoir réfrigéré Le Tassili"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_le-tassili-resto/artifacts/qjocmjxu_WhatsApp%20Image%202026-04-27%20at%2015.21.08%20%282%29.jpeg",
      alt: "Intérieur avec machine à café"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_le-tassili-resto/artifacts/fu2pzzjf_WhatsApp%20Image%202026-04-27%20at%2015.21.08%20%283%29.jpeg",
      alt: "Vue d'ensemble de la salle"
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-b from-black to-[#0F0F0F]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2
            className="text-4xl md:text-5xl font-bold text-[#D4A85F] mb-4"
            style={{ fontFamily: "'Crimson Text', 'Times New Roman', serif" }}
          >
            Notre Restaurant
          </h2>
          <p className="text-lg text-gray-400">
            Découvrez notre établissement en images
          </p>
        </div>

        {/* Photos Grid - Responsive */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
          {restaurantImages.map((image, idx) => (
            <div
              key={idx}
              className="group relative overflow-hidden rounded-xl shadow-lg cursor-pointer transform hover:scale-105 transition-all duration-300"
              onClick={() => setSelectedImage(image)}
            >
              <div className="aspect-square">
                <img 
                  src={image.url}
                  alt={image.alt}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all duration-300 flex items-center justify-center">
                <div className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-center px-2">
                  <p className="text-sm font-semibold">Cliquez pour agrandir</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Image Modal */}
      <Dialog open={!!selectedImage} onOpenChange={() => setSelectedImage(null)}>
        <DialogContent className="max-w-5xl bg-black/95 border-2 border-[#D4A85F] p-0">
          {selectedImage && (
            <div className="relative">
              <button
                onClick={() => setSelectedImage(null)}
                className="absolute top-4 right-4 z-10 bg-[#D4A85F] text-black p-2 rounded-full hover:bg-[#E2B978] transition-colors"
              >
                <X size={24} />
              </button>
              <img 
                src={selectedImage.url}
                alt={selectedImage.alt}
                className="w-full h-auto rounded-lg"
              />
              <div className="p-6 bg-gradient-to-t from-black to-transparent">
                <p className="text-white text-center text-xl font-semibold">
                  {selectedImage.alt}
                </p>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
};
